import ShaderBase from "./_shaderBase.js";
export default class Clouds2 extends ShaderBase {}
Clouds2.prototype.defaultOptions = {
  backgroundColor: 0x000000,
  skyColor: 0x5ca6ca,
  cloudColor: 0x334d80,
  lightColor: 0xffffff,
  speed: 1,
  scaleMobile: 2,
};
// Coherent volumetric noise replaces the absent external noise texture and
// evaluation-order-dependent texture macro. No radial seed: no concentric bands.
Clouds2.prototype.fragmentShader = `
uniform vec2 iResolution; uniform vec2 iMouse; uniform float iTime;
uniform vec3 skyColor; uniform vec3 cloudColor; uniform vec3 lightColor;
float hash(vec3 p){return fract(sin(dot(p,vec3(127.1,311.7,74.7)))*43758.5453);}
float noise3(vec3 p){vec3 i=floor(p),f=fract(p);f=f*f*(3.-2.*f);return mix(mix(mix(hash(i),hash(i+vec3(1,0,0)),f.x),mix(hash(i+vec3(0,1,0)),hash(i+vec3(1,1,0)),f.x),f.y),mix(mix(hash(i+vec3(0,0,1)),hash(i+vec3(1,0,1)),f.x),mix(hash(i+vec3(0,1,1)),hash(i+vec3(1,1,1)),f.x),f.y),f.z);}
float density(vec3 p){float n=noise3(p)*.55+noise3(p*2.03)*.28+noise3(p*4.01)*.14;return max(0.,n-.42-abs(p.y)*.13);}
void main(){vec2 uv=(gl_FragCoord.xy-.5*iResolution)/iResolution.y;uv+=(iMouse/iResolution-.5)*.12;
vec3 ray=normalize(vec3(uv.x,uv.y+.15,1.3));vec3 color=mix(skyColor*.6,skyColor,clamp(uv.y+.7,0.,1.));float trans=1.;
for(int i=0;i<48;i++){vec3 p=vec3(0.,.1,iTime*.12)+ray*(float(i)*.14);float d=density(p);float light=clamp((density(p)-density(p+vec3(.2,.4,-.1)))*3.+.6,0.,1.);float a=1.-exp(-d*.5);color+=trans*a*mix(cloudColor,lightColor,light);trans*=1.-a;}
gl_FragColor=vec4(color,1.);}`;
